import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';
import { Paragraph, View } from '@uncinc/react-drupal-core';
import Helmet from 'react-helmet';
import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import i18next from '../../../../config/i18next';


import {
  WysiwygField,
  Container,
  Breadcrumbs,
  Divider,
  Share,
} from '../../../../components';

import './style.scss';
import { formatDate } from '../../../../helpers/dates';

const NodeBlogFull = ({ entity, className }) => {
  const classes = classNames(className);
  const id = entity.getIn(['nid', 0, 'value']);
  const date = formatDate(entity.getIn(['created', 0, 'value'], new Date()));
  const authorEntityId = entity.getIn(['field_author_paragraph', 0, 'target_id']);
  const authorEntity = entity.getIn(['field_author_paragraph', 0, 'entity']);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Helmet>
        <meta property="og:image" content={entity.getIn(['field_image', 0, 'styles', 'large'])} />
      </Helmet>
      <div className="BlogPage full">
        <Container>
          <div className="row">
            <div className="col-12">
              <Breadcrumbs includeCurrent />
            </div>
            <div className="col-12 col-md-8 offset-md-2">
              <div className="BlogPage__date">{date}</div>
              <h1 className="BlogPage__title">{entity.getIn(['title', 0, 'value'])}</h1>
              {entity.getIn(['body', 0, 'processed']) ? (
                <WysiwygField
                  property="schema:text"
                  className="BlogPage__body"
                  html={entity.getIn(['body', 0, 'processed'], '')}
                />
              ) : null}
            </div>
            <div className="col-12">
              {entity.getIn(['field_image']).size > 0 && (
                <div className="BlogPage__image">
                  <Image
                    src={{
                      0: entity.getIn(['field_image', 0, 'styles', 'large'], ''),
                      768: entity.getIn(['field_image', 0, 'styles', 'basic_image'], ''),
                    }}
                    includeWebP
                  />
                </div>
              )}
            </div>
            <div className="col-12 col-md-8 offset-md-2">
              <div className="Paragraphs">
                {
                  entity.getIn(['field_paragraphs'], List()).map((item, index) => {
                    const paragraphId = item.get('target_id');
                    const paragraph = item.getIn(['entity']);
                    return (
                      <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} containerless />
                    );
                  })
                }
                <Paragraph entity={authorEntity} id={authorEntityId} containerless />
              </div>
              <Share title={i18next.t('share')} />
            </div>
          </div>
        </Container>
        <Divider className="related-divider" />
        <View id="related_blogs" display="block_1" args={[id]} />
      </div>
    </article>
  );
};

export default NodeBlogFull;
